import { ErrorBoundaryBase, useI18n } from "@jog/react-components"
import React, { PropsWithChildren } from "react"

const ErrorBoundaryFC = ({ system, children }: PropsWithChildren<{ system?: string }>) => {
    const { $t } = useI18n()
    return (
        <ErrorBoundaryBase
            errorGeneral={$t("Error general:")}
            tryAgain={$t("Something went wrong please try again")}
            system={system}>
            {children}
        </ErrorBoundaryBase>
    )
}

export const ErrorBoundary = React.memo(ErrorBoundaryFC)
